import { render, staticRenderFns } from "./OrdersListTable.vue?vue&type=template&id=88944fa0&scoped=true"
import script from "./OrdersListTable.vue?vue&type=script&lang=js"
export * from "./OrdersListTable.vue?vue&type=script&lang=js"
import style0 from "./OrdersListTable.vue?vue&type=style&index=0&id=88944fa0&lang=scss&scoped=true"
import style1 from "./OrdersListTable.vue?vue&type=style&index=1&id=88944fa0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88944fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88944fa0')) {
      api.createRecord('88944fa0', component.options)
    } else {
      api.reload('88944fa0', component.options)
    }
    module.hot.accept("./OrdersListTable.vue?vue&type=template&id=88944fa0&scoped=true", function () {
      api.rerender('88944fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/components/OrdersListTable.vue"
export default component.exports